// extracted by mini-css-extract-plugin
module.exports = {"button":"button__37MXk","hover":"hover__9jZ4L","blueButton":"blueButton__2J_Jc","removeArrow":"removeArrow__2hsh9"};